// extracted by mini-css-extract-plugin
export default {"NavButton":"NavButton-module__NavButton___lljW"};